// `react-app-polyfill/ie11`, `react-app-polyfill/stable`, その他の順で定義する必要がある
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from 'react-query';
import App from 'routes/App';
import Login from 'routes/Login';
import SecuritiesAccountManagementLP from 'routes/SecuritiesAccountManagementLP';
import TargetLP from 'routes/TargetLP';
import InvestorBenefitsLP from 'routes/InvestorBenefitsLP';
import LpNotificationDetail from 'routes/LpNotificationDetail';
import PostNotificationListDetail from 'routes/PostNotificationListDetail';
import PostNotificationList from 'routes/PostNotificationList';
import Auth from 'routes/Auth';
import TemporaryLogin from 'routes/TemporaryLogin';
import Maintenance from 'routes/Maintenance';
import PremiumLp from 'routes/PremiumLp';
import AnotherServiceAlignment from 'routes/AnotherServiceAlignment';
import { getProxyAgent } from 'utils/utils';
import * as serviceWorkerRegistration from 'serviceWorkerRegistration';
import * as env from 'config/environment';
import './App.css';
import { CustomizeHeaderProvider } from 'contexts/CustomizeHeaderContext';
import { CustomizeFooterProvider } from 'contexts/CustomizeFooterContext';
import { AppUIProvider } from 'contexts/AppUIContext';
import { TargetAchievementSupportProvider } from 'contexts/TargetAchievementSupportContext';
import { GlobalMenuProvider } from 'contexts/GlobalMenuContext';

// getProxyAgentでopenerのオブジェクトにアクセスしているので、ここでdocument.domain変えておかないとアクセスエラーになる
// HACK: デプロイの手間を考える必要があるが、代行用の口を作った方がより安全(ビルド時に代行か否かを決定する)
document.domain =
  process.env.NODE_ENV === 'production' ? 'tw.minkabu.jp' : 'localhost';

// sessionStorageを都度チェックするので、テスト用にSessionIDを設定している場合は、ダミーのデータを入れておく
const proxyAgent = getProxyAgent();
if (env.TEST_REAL_DATA_SESSIONID || proxyAgent) {
  document.title = proxyAgent ? '代行ログイン' : document.title;

  const id = proxyAgent ? 'proxy' : 'test';
  sessionStorage.setItem(
    'user',
    JSON.stringify({
      ID: id,
      Name: `${id} user`,
      MailAddress: `${id}@map.co.jp`,
      ProfileImageURL: null,
      Charged: proxyAgent?.charged ?? true,
      LastLoginDateTime: new Date(),
      NewUserAndInverstorIDNotIssued: false,
      RegisteredWebPush: true,
    })
  );
}

const queryClient = new QueryClient();

render(
  <Router>
    <CustomizeHeaderProvider>
      <CustomizeFooterProvider>
        <AppUIProvider>
          <QueryClientProvider client={queryClient}>
            <TargetAchievementSupportProvider>
              <GlobalMenuProvider>
                <HelmetProvider>
                  <Switch>
                    <Route path="/" exact component={Login}></Route>
                    <Route
                      path="/securitiesAccountManagementLP"
                      exact
                      component={SecuritiesAccountManagementLP}></Route>
                    <Route path="/targetLP" exact component={TargetLP}></Route>
                    <Route
                      path="/investor_benefits"
                      exact
                      component={InvestorBenefitsLP}></Route>
                    <Route
                      path="/lpNotificationDetail/:notificationID"
                      exact
                      component={LpNotificationDetail}></Route>
                    <Route
                      path="/postNotificationList/:notificationID"
                      exact
                      component={PostNotificationListDetail}></Route>
                    <Route
                      path="/postNotificationList"
                      exact
                      component={PostNotificationList}></Route>
                    <Route
                      path="/maintenance"
                      exact
                      component={Maintenance}></Route>
                    <Route path="/auth" exact component={Auth}></Route>
                    <Route
                      path="/temporarylogin"
                      exact
                      component={TemporaryLogin}></Route>
                    <Route
                      path="/premiumlp"
                      exact
                      component={PremiumLp}></Route>
                    <Route
                      path="/anotherservicealignment"
                      exact
                      component={AnotherServiceAlignment}></Route>
                    <Route path="*" component={App}></Route>
                  </Switch>
                </HelmetProvider>
              </GlobalMenuProvider>
            </TargetAchievementSupportProvider>
          </QueryClientProvider>
        </AppUIProvider>
      </CustomizeFooterProvider>
    </CustomizeHeaderProvider>
  </Router>,
  document.getElementById('root')
);

serviceWorkerRegistration.register({
  onUpdate: registration => {
    if (registration.waiting) {
      registration.waiting?.postMessage({ type: 'SKIP_WAITING' });
      window.location.reload();
    }
  },
});
